import React from 'react'

import { AlertStore, Alert } from '../stores/AlertStore'
import AlertEditor from './AlertEditor'

export default class Alerts extends React.Component {
  state = {
    creatingAlert: null,
    editingAlert: null,
    showAlertEditor: false,
    alerts: [],
  }

  componentDidMount() {
    AlertStore.on('set-alert', (e) => {
      var targetPrice = e[1].toFixed(8)
      var symbol = e.symbol
      var creatingAlert = new Alert(symbol, targetPrice)
      var showAlertEditor = true
      this.setState({creatingAlert, showAlertEditor})
    })

    this.setState({alerts: AlertStore.getAlerts()})
  }

  prettify(symbol) {
    const [a, b] = symbol.split('_')
    return b + a
  }

  renderAlert = (a) => {
    return (
      <div key={a.id} className='dbi pa0 mr2 mini-alert'>
        <a href="#alerts" className='no-underline bg-animate'
            onClick={() => {
              this.setState({editingAlert: a, showAlertEditor: true})
          }}>
          <span className='f6'>{this.prettify(a.symbol)}&nbsp;</span>
          {AlertStore.getDescriptionForTriggerType(a.trigger)}&nbsp;
          <br/><span className='f6'>{a.target}</span>
        </a>
      </div>
    )
  }

  alerts = () => {
    return (
      <div className='di pl0 ma0'>
        {this.state.alerts.map(a => {
          return this.renderAlert(a)
        })}
      </div>
    )
  }

  getAlert = () => {
    if (this.state.creatingAlert) {
      return this.state.creatingAlert
    } else {
      return this.state.editingAlert
    }
  }

  deleteAlert = () => {
    AlertStore.unset(this.state.editingAlert)
    this.setState({
      showAlertEditor: false,
      editingAlert: null,
      alerts: AlertStore.getAlerts()
    })
  }

  onEditorClose = () => {
    this.setState({
      showAlertEditor: false,
      creatingAlert: null,
      editingAlert: null,
    })
  }

  onEditorSave = () => {
    if (this.state.creatingAlert) {
      AlertStore.set(this.state.creatingAlert)
    } else {
      this.state.editingAlert.reset()
      AlertStore.save()
    }

    this.onEditorClose()
  }

	render() {
		return (
			<div className="overflow-x-auto">
        <a className='f5 no-underline bg-animate inline-flex items-center pv2 ph3 ba border-box mr2'
          onClick={() => this.props.onExit()}
          href="#charts">
          Close
        </a>

				<span className='i pr2'>Click on chart to set alert.</span>

        { this.alerts() }

        {this.state.showAlertEditor &&
          <AlertEditor alert={this.getAlert()}
            onCancel={this.onEditorClose}
            onSave={this.onEditorSave}
            canDelete={this.state.creatingAlert == null}
            onDelete={this.deleteAlert}
          />
        }
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/components/Alerts.js